import { useTranslation } from 'react-i18next';
import type { Playlist } from '@ghostscreen/contracts';
import type { GroupCardModel } from './buildGroupCardModel';
import { GroupCard } from './GroupCard';

type GroupCardGridProps = {
  organisationId: string;
  models: GroupCardModel[];
  playlists: Playlist[];
  onEdit: (groupId: string) => void;
  onNew: () => void;
  onAssigned: () => void;
};

/** Groups card grid + dashed New group tile — Ghost Screen Groups.dc.html. */
export function GroupCardGrid({
  organisationId,
  models,
  playlists,
  onEdit,
  onNew,
  onAssigned,
}: GroupCardGridProps) {
  const { t } = useTranslation('groups');
  return (
    <div className="flex flex-col gap-[22px]" style={{ animation: 'gs-in 260ms ease both' }}>
      <p
        className="m-0 max-w-[660px] text-[15px]"
        style={{ color: 'var(--gs-ink2)', lineHeight: 1.5, textWrap: 'pretty' }}
      >
        {t('grid.intro')}
      </p>

      <div className="grid grid-cols-[repeat(auto-fill,minmax(min(100%,340px),1fr))] gap-4">
        {models.map((model) => (
          <GroupCard
            key={model.group.id}
            organisationId={organisationId}
            model={model}
            playlists={playlists}
            onEdit={() => onEdit(model.group.id)}
            onAssigned={onAssigned}
          />
        ))}

        <button
          type="button"
          onClick={onNew}
          className="flex min-h-[220px] flex-col items-center justify-center gap-2.5 rounded-[14px] border-[1.5px] border-dashed text-[15px] font-bold"
          style={{
            color: 'var(--gs-muted)',
            background: 'transparent',
            borderColor: 'var(--gs-line)',
            fontFamily: 'inherit',
          }}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            aria-hidden
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
          {t('grid.newGroup')}
        </button>
      </div>
    </div>
  );
}
